import PropTypes from "prop-types";
import styles from "./styles/DraftCourse.module.css";
import React, { useEffect } from "react";
import clsx from "clsx";
import { Link, useNavigate } from "react-router-dom";
import { TableCustom } from "@components";
// import PropTypes from 'prop-types';
import stylesMyCourses from "@pages/InstructorCoursesPage/MyCoursesTab/styles/MyCoursesTab.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getUpcomingCoursesAction,
  deleteCourseAction,
  getMyCoursesAction,
} from "@redux/actions";
import moment from "moment";
import { ConfirmModal } from "@components/ConfirmModal/ConfirmModal";
import { FilterLayout } from "../FilterLayout/FilterLayout";

const DraftCourse = (props) => {
  // state

  // variables

  // logics before hooks

  // hooks

  // logics

  // UI partials

  // effects

  // render
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { myCourses } = useSelector((state) => state.instructorCourse);
  const { deleteCourse } = useSelector((state) => state.course);

  // useEffect(() => {
  //   dispatch(getMyCoursesAction({ isActive: false }));
  // }, [deleteCourse]);

  const editCourse = (courseId) => {
    navigate(`/update-course/${courseId}`, {
      state: { isUpdate: true },
    });
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
    },
    {
      title: "Create Date",
      dataIndex: "createdAt",
      render: (publishDate) => {
        return (
          <div>{`${moment(publishDate)
            .add("hours", 7)
            .format("DD MMMM YYYY | HH:mm")}`}</div>
        );
      },
    },
    // {
    //   title: "Sales",
    //   dataIndex: "sale",
    // },
    // {
    //   title: "Parts",
    //   dataIndex: "parts",
    // },
    {
      title: "Category",
      dataIndex: "category",
      render: (category) => {
        return (
          <Link
            to={`/explore?CategoryId=${category.id}`}
            className="text-decoration-none"
          >
            {category.name}
          </Link>
        );
      },
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   // dataIndex: "status",
    //   render: (status) => {
    //     switch (status) {
    //       case 0:
    //         return <strong className="text-info">Pending</strong>;
    //       case 1:
    //         return <strong className="text-success">Approved</strong>;
    //       case 3:
    //         return <strong className="text-warning">Rejected</strong>;
    //       case 4:
    //         return <strong className="text-danger">Blocked</strong>;

    //       default:
    //         break;
    //     }
    //   },
    // },
    {
      title: "Actions",
      dataIndex: "id",
      render: (id) => {
        return (
          <div>
            <i
              className={clsx("bi bi-pencil-square", styles.icon)}
              onClick={() => {
                editCourse(id);
              }}
            ></i>
            <ConfirmModal
              onSubmit={() => {
                dispatch(deleteCourseAction({ id: id, type: "course" }));
              }}
              title="Delete Course"
              submitButton="Delete"
              body="Are you sure to delete this course?"
            >
              <i className={clsx("bi bi-trash ml-2", styles.icon)}></i>
            </ConfirmModal>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <FilterLayout pagination={myCourses.pagination} isActive={false}>
        <TableCustom
          columns={columns}
          dataSource={myCourses.data}
          isLoading={myCourses.processing}
        />
      </FilterLayout>
    </>
  );
};

/* required: display name */
DraftCourse.displayName = "DraftCourse";

/* required: props types */
DraftCourse.propTypes = {};

/* required: default props */
DraftCourse.defaultProps = {};

export { DraftCourse };
